<template>
	<div>
		<Loader :show="loading" />
		<template v-for="item in items">
			<router-link
				tag="a"
				:to="`/events/${item.id}`"
				class="card d-block bg-12dp mb-2 p-2 w-100"
				v-ripple
				:key="item.id"
			>
				<div class="d-flex justify-content-between">
					<div class="card-date">
						<div class="month">{{ item.startAt | moment("MMM") }}</div>
						<div class="day">{{ item.startAt | moment("DD") }}</div>
						<div class="hour">{{ item.startAt | moment("HH:mm") }}</div>
					</div>
					<div class="card-body">
						<div class="d-flex justify-content-between">
							<div>
								<div class="card-top">
									<span v-if="item.car">{{ item.car.mat }}</span>
								</div>
								<h2 class="card-title">{{ item.name }}</h2>
								<p class="text-white p-0">{{ item.location.name }}</p>
							</div>
							<div>
								<div class="card-top">
									<span>EVENTO</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</router-link>
		</template>

		<div class="alert bg-12dp text-white opacity-7 text-center" v-if="items.length == 0">
			No se han encontrado eventos activos
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Loader from "@/components/layout/Loader"

export default {
	name: "Events",
	components: {
		Loader
	},
	data() {
		return {
			items: [],
			loading: true
		}
	},
	beforeMount() {
		this.load()
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($status: String) {
							events(status: $status) {
								data {
									id
									code
									name
									image {
										id
										url
									}
									startAt
									location {
										id
										name
										locality {
											name
											region {
												name
											}
										}
										address
										latlng {
											lat
											lng
										}
									}
									status
									statusText
									statusClass
								}
							}
						}
					`,
					variables: {
						status: "ACTIVE"
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.items = data.events.data
					this.loading = false
				})
				.catch((err) => {
					// this.$toast.error("Error al cargar la inspección")
				})
		}
	}
}
</script>

<style scoped>
.card-date {
	max-height: 90px;
}
</style>
